import React from 'react';
import { SectionContainer } from '../../styles';
import { Box, Text, Title, VerticalBox } from '../../../../components';
import { AboutUsProvide as AboutUsProvideType } from '../../../../services/about-us/fetchAboutUsPageContent';
import { COLORS, device, FONTS } from '../../../../constants';
import styled from 'styled-components';
import { AboutUsProvideSwiper } from './AboutUsProvideSwiper';
import { AboutUsProvideSwiperItem } from './AboutUsProvideSwiperItem';
import { MotionAboutUsSwiper, MotionYOffsetBlock } from '../../../../components/Motion';

interface AboutUsProvideProps {
  provide: AboutUsProvideType;
}

const AboutUsProvide = ({ provide }: AboutUsProvideProps) => {
  return (
    <SectionContainer>
      <Box>
        <VerticalBox>
          <AboutUsContainer>
            <AboutUsProvideTextWrapper>
              <Title
                fontFamily={FONTS.TITLE}
                size={36}
                lineHeight={54}
                color={COLORS.SECTION_TITLE}
                title={provide.Title}
              />
              <Text
                text={provide.Subtitle}
                fontFamily={FONTS.SUBTITLE}
                size={22}
                lineHeight={33}
                color={COLORS.SECTION_TEXT}
              />
            </AboutUsProvideTextWrapper>
            <MotionAboutUsSwiper
              imageComponent={
                <AboutUsImage>
                  <img
                    draggable={false}
                    src={provide.Image}
                    alt={'about-us-image'}
                  />
                </AboutUsImage>
              }
              swiperComponent={
                <AboutUsProvideSwiper
                  data={provide.cards}
                  renderItem={item => (
                    <AboutUsProvideSwiperItem
                      item={item}
                      length={provide.cards.length}
                    />
                  )}
                />
              }
            />
          </AboutUsContainer>
        </VerticalBox>
      </Box>
    </SectionContainer>
  );
};
const AboutUsContainer = styled(MotionYOffsetBlock)`
  display: flex;
  position: relative;
  padding-bottom: 100px;
  gap: 60px;
  @media screen and (${device.lg}) {
    gap: 20px;
  }
  @media screen and (${device.md}) {
    flex-direction: column;
  }
  @media screen and (${device.sm}) {
    padding-bottom: 50px;
  }
`;
const AboutUsProvideTextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex: 0 0 30%;
  gap: 60px;
  @media screen and (${device.lg}) {
    gap: 20px;
  }
  @media screen and (${device.md}) {
    flex: 1;
    > h4 {
      font-size: 20px;
      line-height: 1.5;
    }
  }
  @media screen and (${device.sm}) {
    > h4 {
      font-size: 14px;
    }
  }
`;

const AboutUsImage = styled.div`
  width: 630px;
  height: 630px;
  
  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
  @media screen and (${device.lg}) {
    width: 500px;
    height: 500px;
  }
  @media screen and (${device.sm}) {
    width: 400px;
    height: 400px;
  }
`;

export { AboutUsProvide };
